// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"carousalstyles_wrapper__X6Hr6"};